import React from 'react';

var VoiceSearch = function VoiceSearch(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "Voice search"), /*#__PURE__*/React.createElement("path", {
    d: "M12 4a1.5 1.5 0 0 0-1.5 1.5v5a1.5 1.5 0 0 0 3 0v-5A1.5 1.5 0 0 0 12 4zm-.91 15.5v-2.05C7.68 17.07 5 14.588 5 11.5a1 1 0 0 1 2 0c0 2.165 2.202 4 5 4s5-1.835 5-4a1 1 0 0 1 2 0c0 3.033-2.587 5.482-5.91 5.928V19.5h1.41a1 1 0 0 1 0 2h-5a1 1 0 0 1 0-2h1.59zM12 2a3.5 3.5 0 0 1 3.5 3.5v5a3.5 3.5 0 0 1-7 0v-5A3.5 3.5 0 0 1 12 2z",
    fill: "currentColor"
  }));
};

VoiceSearch.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
import iconHandler from './hoc';
export { VoiceSearch as icon };
export default iconHandler(VoiceSearch);